export default __webpack_public_path__ + "static/media/background.c8bc41cf.jpg";